import {Template} from "../../../../components/template/template.jsx";
import Button from "../../../../components/button/button.jsx";
import {FaEraser, FaPlus, FaSearch} from "react-icons/fa";
import {navigateHook} from "../../../../hooks/use-navigate.js";
import {Card} from "../../../../components/card/card.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import {useMemo, useRef, useState} from "react";
import {AgGridReact} from "ag-grid-react";
import {useLoaderData} from "react-router";
import {useQuery} from "@tanstack/react-query";
import BosTagsService from "../../../../services/web/bos-tags-service.js";
import AgGridUtils from "../../../../utils/aggrid-utils.js";

const initialFilter = {
    name: "",
}

export default function BosTags() {
    const navigate = navigateHook();
    const [filter, setFilter] = useState(initialFilter);
    const gridRef = useRef(null);
    const loaderData = useLoaderData();
    const boName = loaderData?.bo_name;

    const { data: bosTags = [], isLoading } = useQuery({
        queryKey: ["bos-tags"],
        queryFn: () => BosTagsService.list(),
    });

    const columnDefs = useMemo(() => ([
        { headerName: "Nome", field: "tag_name", flex: 1, resizable: false, comparator: AgGridUtils.lowerUpCaseComparator, sort: "asc" },
    ]), []);

    const handleClear = () => {
        setFilter(initialFilter);
        gridRef.current?.api?.setGridOption("quickFilterText", "");
        gridRef.current?.api?.paginationGoToFirstPage();
    }

    const handleSearch = () => {
        gridRef.current?.api?.setGridOption("quickFilterText", filter.name);
        gridRef.current?.api?.paginationGoToFirstPage();
    }

    const handleKeyDown = (e) => {
        if (e.key === "Enter") handleSearch();
        if (e.key === "Escape") handleClear();
    }

    const onCellClicked = ({ data }) => {
        if (!data?.id) return;
        navigate(`/bos-tags/form/${data.id}`, true);
    }

    return (
        <Template isLoading={isLoading}>
            <Template.Header>
                <Template.Title>
                    Marcadores de {boName}
                </Template.Title>
                <Button onClick={() => navigate("/bos-tags/form", "/bos-tags/create")}>
                    <FaPlus /> Adicionar marcador
                </Button>
            </Template.Header>
            <Template.Body className="space-y-2">
                <Card>
                    <Card.Body className="flex gap-4">
                        <InputForm
                            id="name"
                            label="Nome"
                            value={filter.name}
                            onChange={(e) => setFilter({ name: e.target.value })}
                            onKeyDown={handleKeyDown}
                            classNameWrapper="flex-1"
                        />
                        <div className="flex gap-2">
                            <Button
                                target="primary-outline"
                                title="Limpar"
                                onClick={handleClear}
                            >
                                <FaEraser />
                            </Button>
                            <Button
                                title="Buscar"
                                onClick={handleSearch}
                            >
                                <FaSearch />
                            </Button>
                        </div>
                    </Card.Body>
                </Card>
                <Card>
                    <Card.Body>
                        <div className="h-[calc(100vh-153px)] aggrid-row-pointer">
                            <AgGridReact
                                ref={gridRef}
                                rowData={bosTags}
                                columnDefs={columnDefs}
                                pagination
                                paginationPageSize={100}
                                paginationPageSizeSelector={[20, 50, 100, 500]}
                                animateRows={false}
                                suppressCellFocus
                                onCellClicked={onCellClicked}
                                gridOptions={{ localeText: AgGridUtils.localization() }}
                                theme={AgGridUtils.generalTheme()}
                            />
                        </div>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    )
}
